import Popup from "../PureComponents/Popup";
import React from "react";

const RenderPopup = ({ verify, message, hide }) => {
  return <Popup verify={verify} message={message} hide={hide} />;
};

export default RenderPopup;
